import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-confirm-positive',
  templateUrl: './confirm-positive.component.html',
  styleUrls: ['./confirm-positive.component.scss']
})
export class ConfirmPositiveComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
